<template>
  <div id="app">
    <div v-if="modeDevelopment" class="bg-danger text-center text-white">
      <strong>{{ $t("development") }}</strong>
    </div>
    <notifications></notifications>
    <router-view />
    <div id="overlay" v-if="overlay">
      <div class="loading">
        <b-img
          width="100"
          :src="require('@/assets/img/brand/loader.gif')"
          alt=""
        />
        <div class="progress">
          <div class="progress-value"></div>
        </div>
      </div>
    </div>
    <div class="contenedor">
      <button
        class="botonF1 bg-primary text-white"
        @click="$refs.download.showModal()"
      >
        <i class="ri-download-cloud-line"></i>
      </button>
    </div>
    <download-app ref="download" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DownloadApp from "@/components/DownloadApp.vue";
export default {
  components: {
    DownloadApp,
  },
  mounted() {
    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = "o/";
      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      if (e) {
        localStorage.removeItem("ref");
      }
    });
  },
  computed: {
    ...mapGetters({
      overlay: "config/overlay",
    }),
    modeDevelopment() {
      return process.env.NODE_ENV == "development" ? true : false;
    },
  },
};
</script>
<style>
#nprogress .bar {
  background: #29d !important;
  height: 4px !important;
}
.vs__dropdown-toggle {
  border: none;
}
.vs__search {
  color: rgb(189, 189, 189);
}
.vti__input::-webkit-input-placeholder {
  color: rgb(189, 189, 189) !important;
}
</style>
<style scoped>
#overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1051;
  cursor: pointer;
}
.loading {
  position: absolute;
  left: calc(50% - 35px);
  top: 40%;
  width: 50%;
  height: 50%;
  border-radius: 90%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid transparent;
}
.progress {
  background: rgba(255, 255, 255, 0.1);
  justify-content: flex-start;
  border-radius: 100px;
  align-items: center;
  position: relative;
  padding: 0 5px;
  display: flex;
  height: 10px;
  width: 99px;
}

.progress-value {
  animation: load 3s normal forwards;
  box-shadow: 0 10px 40px -10px #fff;
  border-radius: 100px;
  background: #fff;
  height: 30px;
  width: 0;
}

@keyframes load {
  0% {
    width: 0;
  }
  100% {
    width: 90%;
  }
}
header {
  height: 170px;
  color: #fff;
  font-size: 20px;
  font-family: Sans-serif;
  background: #009688;
  padding-top: 30px;
  padding-left: 50px;
}
.contenedor {
  width: 90px;
  height: 240px;
  position: absolute;
  right: 0px;
  bottom: 0px;
}
.botonF1 {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  right: 0;
  bottom: 0;
  position: fixed;
  margin-right: 16px;
  margin-bottom: 16px;
  border: none;
  outline: none;
  font-size: 26px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  transition: 0.3s;
}
</style>